export default __webpack_public_path__ + "static/media/ReactLogo.21a83e0b.svg";